import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GooglePlacesAutocompleteComponent } from '@sml/forms';
import { CampaignTypeEnum, CampaignTypeEnumm, IGoogleSearchAddress, NumericInputDirective } from '@sml/utility';
import { IconsComponent } from '@sml/icons';

@Component({
  selector: 'sml-item-location',
  imports: [CommonModule, ReactiveFormsModule, GooglePlacesAutocompleteComponent, NumericInputDirective, IconsComponent],
  templateUrl: './item-location.component.html',
})
export class ItemLocationComponent {

  @Input() form!: FormGroup;
  @Input() campaignType!: number;
  campaignStatus = CampaignTypeEnumm;
  @Input() isDonated = false;

  get control() {
    return this.form.controls;
  }

  onPlaceSelected(place: IGoogleSearchAddress) {
    this.control['address'].patchValue(place.formattedAddress);
    this.control['longitude'].patchValue(place.long ?? this.control['longitude'].value);
    this.control['latitude'].patchValue(place.lat ?? this.control['latitude'].value);
    
  }
}
